interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav aria-label="分页" className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onChange(currentPage - 1)}
        className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border px-3 py-2 text-xs transition-colors ${
          currentPage === 1
            ? 'cursor-not-allowed border-background-200 bg-background-100 text-foreground-300'
            : 'border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-primary-600'
        }`}
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          aria-current={page === currentPage ? 'page' : undefined}
          onClick={() => onChange(page)}
          className={`h-9 w-9 cursor-pointer rounded-md border text-xs transition-colors ${
            page === currentPage
              ? 'border-primary-500 bg-primary-500 font-semibold text-background-50'
              : 'border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-primary-600'
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={currentPage === totalPages}
        onClick={() => onChange(currentPage + 1)}
        className={`flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border px-3 py-2 text-xs transition-colors ${
          currentPage === totalPages
            ? 'cursor-not-allowed border-background-200 bg-background-100 text-foreground-300'
            : 'border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-primary-600'
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}